// SYSTEM-AGENT (Andrei, 2026-10-29): `/c/{slug}/system-agents/{id}` — a platform super admin's
// private space with the company's system agent, inside the company's context while acting there.
// Company users get the not-found page without an API call; the API answers 404 to anyone but a
// super admin too, so a direct URL reaches nothing.
import { createRoute } from "@tanstack/react-router";
import { isOperator } from "../features/company";
import { SystemAgentSpace } from "../features/operator/system-agent-space";
import { useCompany, useSession } from "../features/use-feature";
import { NotFoundPage } from "../pages/status-pages";
import { companyRoute } from "./c.$slug";

export const companySystemAgentRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "system-agents/$id",
  component: function CompanySystemAgent() {
    const { api } = companySystemAgentRoute.useRouteContext();
    const { id } = companySystemAgentRoute.useParams();
    const { me } = useSession();
    const company = useCompany();
    if (!isOperator(me)) return <NotFoundPage />;
    return <SystemAgentSpace api={api} companyId={company.id} membershipId={id} inCompany />;
  },
});
